/*
 * 智能推荐域接口：推荐 / 饲喂量 / 商品 / 宠物档案
 * 数据源由后端 srs.portalEnabled 开关决定（Global/Akeneo 旧源 或 SRS V4），
 * 前端经统一请求层解包后拿到的结构对两个数据源保持一致（SRS 分支为 AjaxResult.data）。
 *
 * @Author: Mustafa.Yin
 * @Date: 2026-10-31
 */
import { get, post } from '@/utils/request';

/**
 * 智能推荐：入参为 { pet: {...} } 结构
 * @returns {Promise<Array>} 推荐结果列表（product/coverage 结构）
 */
export function smartreco(pet) {
  return post('smartreco/api/smartreco', pet, { apiName: 'smartreco' });
}

/**
 * 饲喂量推荐
 * @param {object} pet RationingRequest 结构（pet/dryProduct/wetProduct/logId 等）
 * @returns {Promise<object>} RationingResponse（diagnostic/dryRation/wetRation/advicesList 等）
 */
export function rationing(pet) {
  return post('smartreco/api/rationing', pet, { apiName: 'rationing' });
}

/**
 * 商品详情（带 logId 变体，后端用其做链路追踪）
 * @returns {Promise<object>} 详情结构（旧源为 Akeneo ES hits，SRS 源为 ProductDetailResponse，调用方按结构判定）
 */
export function productDetail(id, logId) {
  const url = logId ? `smartreco/api/product/${id}/${logId}` : `smartreco/api/product/${id}`;
  return get(url, null, { apiName: 'product' });
}

/**
 * 干粮匹配湿粮（V4 推荐结果 relatedProducts 恒为 null 后，湿粮匹配由此接口承接）
 * @returns {Promise<object>} 湿粮商品详情
 */
export function productMatchWet(id) {
  return get(`smartreco/api/productMatchWet/${id}`, null, { apiName: 'productMatchWet' });
}

/**
 * 宠物档案：按生日+品种+性别推生命阶段（lifestage）
 * @returns {Promise<object>} petProfile 结构（petType.lifestage 等）
 */
export function petProfile(pet) {
  return post('smartreco/api/petProfile', pet, { apiName: 'petProfile' });
}

/**
 * 本地商品信息（商品图 mimeType / benefits 兜底）
 * @returns {Promise<object>} 本地商品记录
 */
export function getCommodityByCommodityId(commodityId) {
  return get('smartreco/api/getCommodityByCommodityId', { commodityId }, { apiName: 'getCommodity' });
}

/**
 * 商品列表（自行选择流程）
 * @param {string} animal 宠物类型编码（speciesCode）
 * @param {string} commercialLabel 商品名（模糊搜索）
 */
export function getCommodityListByParam(animal, commercialLabel) {
  return get('smartreco/api/getCommodityListByParam', { animal, commercialLabel }, { apiName: 'commodityList' });
}
